import React, { useState } from "react";
import Sidebar from "../Sidebar/Sidebar";

const PageContainer = ({ children, heading }) => {
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend = {heading} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="content-container">
          <h2 className="main-heading">{heading}</h2>
          <br></br>
          {children}
        </div>
      </div>
    </>
  );
};

export default PageContainer;
